module.exports = __webpack_public_path__ + "img/JPUTLogoHorizontalBlack.76250887.png";